import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import ProductService from "../../../services/ProductService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useNavigate } from "react-router-dom";
import PackService from "../../../services/PackService";
import WarehouseService from "../../../services/WarehouseService";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddTesteur = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);

  const [productBarCode, setProductBarCode] = useState("none");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [product, setProduct] = useState(null);
  const [productId, setProductId] = useState(0);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [isClickedProduct, setIsClickedProduct] = useState(false);
  const animatedComponents = makeAnimated();
  const [selectedOptionWarehouse, setSelectedOptionWarehouse] = useState(null);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState(null);
  const [allWarehouse, setAllWarehouse] = useState([{}]);
  const [name, setName] = useState("");
  const [listWarehouseId, setListWarehouseId] = useState([]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [selectedOption, setSelectedOption] = useState(null);

  const onChangeBarCodeHandler = (event) => {
    setProductBarCode(event.target.value);
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  useEffect(() => {
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, []);
  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  const getProdcutByCodeArticle = () => {
    if (productBarCode === "none") {
      setOpenErrorAlert(true);
      setErrorAlertText("vous devez choisir un article");
    } else {
    
        ProductService.getProductByBarCode(getCurrentUserId(), productBarCode)
        .then((response) => {
          if (response.data.products?.length !== 0) {
            console.log("response",response.data.products.id);
            setProduct(response.data?.products);
            setProductId(response.data?.products?.id);
            setIsClickedProduct(true);
          } else {
            setOpenInfoAlert(true);
            setInfoAlertText("Aucun produit de ce code article");
          }
          console.log("product", response);
        })
        .catch((e) => {
          setOpenErrorAlert(true);
          setErrorAlertText(e);
        });
    }
  };

  const productInfos = () => {
    if (isClickedProduct && product !== null) {
      return (
        <div className="col-sm-12">
          {" "}
          <label>Produit choisit :</label> {" "}
          <label>
            {product?.productCode}-{product?.barcode}-{product?.name}
          </label>
        </div>
      );
    }
  };

  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };
  const onConfirmAddProductHandler = () => {
  
    startLoading();
    PackService.addPackByRefProductBarCode(
      getCurrentUserId(),
      warehouseSourceId,
      productBarCode,
      name
    )
      .then((result) => {
        console.log("result", result);
        if (result.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/pack`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };
  return (
    <section className="content-wrapper" style={{ marginTop: "0%" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Testeurs et gratuités</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div class="card">
            <div class="card-header  ">
              <h3 class="card-title">Ajouter un pack gratuit</h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                  title="Collapse"
                >
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="card-body ">
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <label>Choisir le dépôt </label>
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        style={{ width: "95%" }}
                      >
                        <Select
                          styles={styles}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOption}
                          onChange={onChangeSelectedWarehouseSource}
                          options={allWarehouseSource}
                          placeholder={warehouseSelectPlaceHolder}
                        />
                      </div>
                     
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label htmlFor="inputName">Libellé</label>
                    <input
                      onChange={onChangeNameHandler}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label htmlFor="inputName">Choisir code à barre </label>
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        style={{ width: "90%" }}
                      >
                        <input
                          onChange={onChangeBarCodeHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />{" "}
                      </div>
                      <div className=" input-group-append">
                        <button
                          onClick={getProdcutByCodeArticle}
                          type="button"
                          class="btn btn-dark"
                        >
                          <i class="fas  fa-solid fa-arrow-down"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
              <div class="row">
              <div className="col-sm-12">
                {productInfos()}
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                class="btn btn-dark float-right"
                onClick={onConfirmAddProductHandler}
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>{" "}
    </section>
  );
};
export default withLoader(AddTesteur);
